import styled from "styled-components";

const PlatformTableBody = styled.div`
  padding:18px 20px 20px;

  && > section > div:last-child {
    overflow:hidden;
    border:1px solid #dfe6ed !important;
    border-bottom-color:#d5dee7 !important;
    border-radius:8px !important;
    background:#fff;
    box-shadow:none !important;
  }

  && .InovuaReactDataGrid,
  && .InovuaReactDataGrid--theme-default-light {
    overflow:hidden;
    border:1px solid #dfe6ed !important;
    border-radius:8px !important;
    background:#fff;
    color:#46515d;
    font-size:11px;
    box-shadow:none !important;
  }

  && .InovuaReactDataGrid__header,
  && .InovuaReactDataGrid__column-header {
    border-color:#cddff5 !important;
    background:#f2f7fd !important;
  }

  && .InovuaReactDataGrid__header {
    border-bottom:2px solid #8bb8ea !important;
  }

  && .InovuaReactDataGrid__column-header {
    min-height:42px;
    color:#34475a;
    font-size:11px;
    font-weight:750;
  }

  && .InovuaReactDataGrid__row {
    min-height:48px;
    border-color:#edf1f4 !important;
    background:#fff;
    color:#46515d;
    font-size:11px;
    transition:background .15s ease, box-shadow .15s ease;
    cursor:pointer;
  }

  && .InovuaReactDataGrid__row:nth-child(even) {
    background:#fcfdfe;
  }

  && .InovuaReactDataGrid__row:hover {
    background:#f7fbff !important;
    box-shadow:inset 3px 0 0 var(--theme-primary);
  }

  && .InovuaReactDataGrid__cell {
    border-color:#edf1f4 !important;
    padding-right:12px;
    padding-left:12px;
    color:#46515d;
    font-size:11px;
  }

  && .InovuaReactDataGrid__cell a,
  && .InovuaReactDataGrid__cell button {
    font-size:11px;
  }

  && .InovuaReactDataGrid__cell a {
    color:var(--theme-primary-strong) !important;
    font-weight:700;
    text-decoration:none;
  }

  && .InovuaReactDataGrid__cell a:hover {
    color:var(--theme-primary-hover) !important;
    text-decoration:underline;
  }

  && .InovuaReactDataGrid__empty-text {
    color:#8a949f;
    font-size:11px;
  }

  @media(max-width:720px) {
    padding:14px;
    && .InovuaReactDataGrid__column-header,
    && .InovuaReactDataGrid__row,
    && .InovuaReactDataGrid__cell {font-size:10px;}
  }
`;

export default PlatformTableBody;
